export default __webpack_public_path__ + "static/media/first-right-img@1x.63340c4a.webp";